export default function startIntersectionObserver() {
  const callbacks = {}
  let uniqueId = 0

  const runCallback = change => {
    const callback = callbacks[change.target.id]
    if (callback) callback(change)
  }

  const observer = new IntersectionObserver(
    changes => {
      changes.forEach(runCallback)
    },
    {
      // fire events on each quarter change
      threshold: [0, 0.25, 0.5, 0.75, 1],
      // account for height of top nav
      rootMargin: '-60px',
    }
  )

  const proxy = {
    // our observe takes node *and* callback which will be passed
    // IntersectionChange events that match given node
    observe: (node, callback) => {
      if (!node.id) node.id = `id_${uniqueId++}`
      observer.observe(node)
      callbacks[node.id] = callback
    },

    unobserve: node => {
      observer.unobserve(node)
      delete callbacks[node.id]
    },
  }

  return proxy
}
